<template>
  <div class="dashboard-header">
      <figure>
          <img :src="avatar">
      </figure>
      <p><strong>{{ account.name }}</strong></p>
      <small>{{ identity_email }}</small>
      <p>
        <span v-if="account.premium.enabled === true" class="button-premium" v-tooltip='"SAPO Mail Premium"'></span>

        <LinkButton v-if="account.premium.visible === true"
          :link="links.premium"
          :text="(AccountController.account.premium.enabled) ? 'user_dashboard.account_premium' : 'user_dashboard.account_free'"
          class='clear'
          target="_blank"
        />
      </p>
  </div>
</template>
<script setup>
  import { ref, onBeforeMount } from 'vue';
  import SAPOMailConfig         from '@/SAPOMailConfig';
  import IdentitiesController   from '@/js/Settings/Identities/IdentitiesController';
  import LinkButton             from '@/vue/Elements/Buttons/LinkButton.vue';
  import AccountController      from '@/js/Webmail/AccountController';

  const links          = SAPOMailConfig.server.external_links;
  const account        = SAPOMailConfig.server.account;
  const avatar         = links.gravatar + '/' + SAPOMailConfig.server.account.mhash;
  const identity_email = ref('');

  onBeforeMount(() => {
    setEmailDefault();
  });

  const setEmailDefault = () => {
    identity_email.value = IdentitiesController.identities.get(IdentitiesController.identities.default).email || '';
  }
</script>